// FORGE Trailer — Filmmusik & Sound-Effekte (Web Audio, komplett synthetisiert,
// keine externen Dateien → DSGVO-sauber, kein CDN)
let AC = null, master = null, duckGain = null, padStop = null;

// Akkord je Szene (d-Moll-Spannungsbogen, Finale in D-Dur)
const CHORDS = [
  [73.42, 110.00, 146.83],
  [73.42, 87.31, 110.00, 146.83],
  [58.27, 87.31, 116.54, 146.83],
  [73.42, 110.00, 174.61, 220.00],
  [87.31, 130.81, 174.61],
  [65.41, 98.00, 130.81, 164.81],
  [55.00, 110.00, 130.81, 164.81],
  [58.27, 116.54, 146.83, 174.61],
  [49.00, 98.00, 116.54, 146.83],
  [73.42, 110.00, 146.83, 185.00],
];

export function initAudio() {
  if (AC) return;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return;
  AC = new Ctx();
  master = AC.createGain(); master.gain.value = 0.9; master.connect(AC.destination);
  duckGain = AC.createGain(); duckGain.gain.value = 1; duckGain.connect(master);
}

export function audioSuspend(on) { if (AC) (on ? AC.resume() : AC.suspend()); }
export function stopPad() { if (padStop) padStop(); }

function playChord(i) {
  if (!AC) return;
  if (padStop) padStop();
  const freqs = CHORDS[Math.min(i, CHORDS.length - 1)];
  const now = AC.currentTime;
  const padG = AC.createGain(); padG.gain.setValueAtTime(0, now);
  padG.gain.linearRampToValueAtTime(0.055, now + 2.5);
  const lp = AC.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 640; lp.Q.value = 0.4;
  padG.connect(lp); lp.connect(duckGain);
  const oscs = [];
  freqs.forEach(f => {
    [-6, 5].forEach(det => {
      const o = AC.createOscillator();
      o.type = 'sawtooth'; o.frequency.value = f; o.detune.value = det;
      const g = AC.createGain(); g.gain.value = 1 / (freqs.length * 2);
      o.connect(g); g.connect(padG); o.start(now); oscs.push(o);
    });
  });
  const lfo = AC.createOscillator(), lfoG = AC.createGain();
  lfo.frequency.value = 0.09; lfoG.gain.value = 140;
  lfo.connect(lfoG); lfoG.connect(lp.frequency); lfo.start(now); oscs.push(lfo);
  padStop = () => {
    const t = AC.currentTime;
    padG.gain.cancelScheduledValues(t);
    padG.gain.setValueAtTime(padG.gain.value, t);
    padG.gain.linearRampToValueAtTime(0, t + 2.2);
    oscs.forEach(o => { try { o.stop(t + 2.4); } catch (e) { /* bereits gestoppt */ } });
  };
}

function noiseBurst(dur, filterType, freq, gain) {
  const nb = AC.createBuffer(1, AC.sampleRate * dur, AC.sampleRate), d = nb.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
  const ns = AC.createBufferSource(); ns.buffer = nb;
  const f = AC.createBiquadFilter(); f.type = filterType; f.frequency.value = freq;
  const g = AC.createGain(); g.gain.value = gain;
  ns.connect(f); f.connect(g); g.connect(master); ns.start(AC.currentTime);
}

function braam(strong) {
  if (!AC) return;
  const now = AC.currentTime, dur = strong ? 2.2 : 1.3;
  [36.71, 73.42].forEach((f, k) => {
    const o = AC.createOscillator(); o.type = k ? 'triangle' : 'sine'; o.frequency.value = f;
    const g = AC.createGain();
    g.gain.setValueAtTime(0, now);
    g.gain.linearRampToValueAtTime(strong ? 0.30 : 0.16, now + 0.06);
    g.gain.exponentialRampToValueAtTime(0.001, now + dur);
    o.connect(g); g.connect(master); o.start(now); o.stop(now + dur + 0.1);
  });
  noiseBurst(0.5, 'lowpass', 240, strong ? 0.5 : 0.3);
}

function clang(at) {
  if (!AC) return;
  const now = AC.currentTime + (at || 0);
  [412, 1137, 2226, 3667].forEach((f, k) => {
    const o = AC.createOscillator(); o.type = 'sine'; o.frequency.value = f;
    const g = AC.createGain();
    g.gain.setValueAtTime(0.14 / (k + 1), now);
    g.gain.exponentialRampToValueAtTime(0.0008, now + 1.6 - k * 0.25);
    o.connect(g); g.connect(master); o.start(now); o.stop(now + 1.8);
  });
  noiseBurst(0.12, 'highpass', 1800, 0.22);
}

export function sceneAudio(i, fx, isFinale) {
  if (!AC) return;
  playChord(i);
  if (fx === 'clang') { clang(0.4); clang(1.5); clang(2.6); }
  else braam(i === 3 || isFinale);
}

// Musik leiser, solange der Sprecher spricht
export function duck(down) {
  if (!AC) return;
  const t = AC.currentTime;
  duckGain.gain.cancelScheduledValues(t);
  duckGain.gain.setValueAtTime(duckGain.gain.value, t);
  duckGain.gain.linearRampToValueAtTime(down ? 0.4 : 1, t + (down ? 0.3 : 1.2));
}
